import React, { useState } from 'react';
import useSEO from '../hooks/useSEO';
import NavBar from '../components/Navbar/NavBar';
import Clients from '../components/Clients';
import { Table, List, Award, CheckCircle, ArrowUpRight, Search, ArrowUpDown } from 'lucide-react';

const sectorData = [
    { sector: 'Banking and Finance', totalIPOs: 50, fundsRaised: 870.62, medianSize: 17.41, medianPE: 18.49 },
    { sector: 'Engineering', totalIPOs: 93, fundsRaised: 2076.91, medianSize: 22.33, medianPE: 14.8 },
    { sector: 'Information Technology', totalIPOs: 79, fundsRaised: 1609.87, medianSize: 20.38, medianPE: 17.83 },
    { sector: 'Textiles', totalIPOs: 82, fundsRaised: 1113.7, medianSize: 13.58, medianPE: 19.46 },
    { sector: 'Agro', totalIPOs: 72, fundsRaised: 1274.99, medianSize: 17.71, medianPE: 18.82 },
    { sector: 'Chemical', totalIPOs: 52, fundsRaised: 1192.51, medianSize: 22.93, medianPE: 17.51 },
    { sector: 'Electric Equipments', totalIPOs: 44, fundsRaised: 1196.92, medianSize: 27.2, medianPE: 17.83 },
    { sector: 'Infrastructure', totalIPOs: 41, fundsRaised: 907.85, medianSize: 22.14, medianPE: 17.28 },
    { sector: 'Healthcare', totalIPOs: 39, fundsRaised: 878.15, medianSize: 22.52, medianPE: 19.67 },
    { sector: 'Real Estate', totalIPOs: 39, fundsRaised: 551.77, medianSize: 14.15, medianPE: 20.97 },
    { sector: 'Pharmaceutical', totalIPOs: 35, fundsRaised: 749.18, medianSize: 21.41, medianPE: 19.84 },
    { sector: 'Logistics', totalIPOs: 42, fundsRaised: 924.12, medianSize: 22, medianPE: 15.11 },
    { sector: 'Steel', totalIPOs: 38, fundsRaised: 1058.79, medianSize: 27.86, medianPE: 16.09 },
    { sector: 'Jewellery', totalIPOs: 37, fundsRaised: 522.69, medianSize: 14.13, medianPE: 26.87 },
    { sector: 'Advertising and Media', totalIPOs: 29, fundsRaised: 647.83, medianSize: 22.34, medianPE: 16.67 },
    { sector: 'Corporate Solutions', totalIPOs: 26, fundsRaised: 330.91, medianSize: 12.73, medianPE: 17.15 },
    { sector: 'FMCG', totalIPOs: 20, fundsRaised: 393.26, medianSize: 19.66, medianPE: 16.84 },
    { sector: 'Packaging & Disposables', totalIPOs: 28, fundsRaised: 308.23, medianSize: 11.01, medianPE: 16.44 },
    { sector: 'Plastic and Polymer', totalIPOs: 27, fundsRaised: 472.27, medianSize: 17.49, medianPE: 18.76 },
    { sector: 'Power and Energy', totalIPOs: 12, fundsRaised: 256.82, medianSize: 21.4, medianPE: 17.11 },
    { sector: 'Automobile', totalIPOs: 12, fundsRaised: 206.13, medianSize: 17.18, medianPE: 20.69 },
    { sector: 'Cables and Wires', totalIPOs: 21, fundsRaised: 394.56, medianSize: 18.79, medianPE: 22.19 },
    { sector: 'Furniture', totalIPOs: 21, fundsRaised: 383.55, medianSize: 18.26, medianPE: 18.35 },
    { sector: 'Education', totalIPOs: 14, fundsRaised: 272.69, medianSize: 19.48, medianPE: 19.31 },
    { sector: 'Retail', totalIPOs: 18, fundsRaised: 261.98, medianSize: 14.55, medianPE: 18.72 },
    { sector: 'Telecom', totalIPOs: 10, fundsRaised: 311.08, medianSize: 31.11, medianPE: 12.38 },
    { sector: 'Information Technology - SaaS', totalIPOs: 11, fundsRaised: 188.68, medianSize: 17.15, medianPE: 12.96 },
    { sector: 'Hotels and Resorts', totalIPOs: 9, fundsRaised: 85.79, medianSize: 9.53, medianPE: 18.62 },
    { sector: 'Film and Animation - VFX', totalIPOs: 14, fundsRaised: 325.21, medianSize: 23.23, medianPE: 12.16 },
    { sector: 'Metal', totalIPOs: 13, fundsRaised: 228.79, medianSize: 17.6, medianPE: 18.87 },
    { sector: 'Outsourcing', totalIPOs: 10, fundsRaised: 83.55, medianSize: 8.36, medianPE: 22.5 },
    { sector: 'Solar', totalIPOs: 15, fundsRaised: 441.25, medianSize: 29.42, medianPE: 18.48 },
    { sector: 'Human Resources and Manpower', totalIPOs: 8, fundsRaised: 223.98, medianSize: 28, medianPE: 13.52 },
    { sector: 'Travel and Tourism', totalIPOs: 8, fundsRaised: 139.08, medianSize: 17.39, medianPE: 12.87 },
    { sector: 'Minerals', totalIPOs: 6, fundsRaised: 160.95, medianSize: 26.83, medianPE: 18.3 },
    { sector: 'Ceramic and Stone', totalIPOs: 6, fundsRaised: 135.24, medianSize: 22.54, medianPE: 14.58 },
    { sector: 'Recycling', totalIPOs: 10, fundsRaised: 239.89, medianSize: 23.99, medianPE: 18.85 },
    { sector: 'Defence', totalIPOs: 2, fundsRaised: 47.79, medianSize: 23.9, medianPE: 23.05 },
    { sector: 'Oil and Gas', totalIPOs: 5, fundsRaised: 93.75, medianSize: 18.75, medianPE: 25.25 },
    { sector: 'Aluminium', totalIPOs: 8, fundsRaised: 204.57, medianSize: 25.57, medianPE: 17.16 },
    { sector: 'ESG', totalIPOs: 5, fundsRaised: 174.27, medianSize: 34.85, medianPE: 26.05 },
    { sector: 'E-Commerce', totalIPOs: 6, fundsRaised: 145.32, medianSize: 24.22, medianPE: 10.18 },
    { sector: 'Rubber', totalIPOs: 5, fundsRaised: 50.83, medianSize: 10.17, medianPE: 21.61 },
    { sector: 'Home Decor', totalIPOs: 5, fundsRaised: 127.05, medianSize: 25.41, medianPE: 20.32 },
    { sector: 'Paper and Stationery', totalIPOs: 1, fundsRaised: 93.7, medianSize: 93.7, medianPE: 10.57 },
    { sector: 'Hotels and Resorts - QSR', totalIPOs: 2, fundsRaised: 28.47, medianSize: 14.24, medianPE: 16.14 },
    { sector: 'Valves', totalIPOs: 4, fundsRaised: 87.6, medianSize: 21.9, medianPE: 23.87 },
];

const SME = () => {
    useSEO({
        title: "SME IPO Advisory & Solutions | Yaniva Ventures",
        description: "Complete step-by-step advisory for SME listings on NSE Emerge and BSE SME. Unlock public equity and growth capital with Yaniva."
    });

    const [showTable, setShowTable] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [sortField, setSortField] = useState('sector');
    const [sortDirection, setSortDirection] = useState('asc');

    const toggleTable = () => {
        setShowTable(prevShow => !prevShow);
        setSearchQuery('');
    };

    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(prev => prev === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
    };

    const filteredAndSortedData = sectorData
        .filter(item => item.sector.toLowerCase().includes(searchQuery.toLowerCase()))
        .sort((a, b) => {
            let valA = a[sortField];
            let valB = b[sortField];
            
            if (typeof valA === 'string') {
                return sortDirection === 'asc' 
                    ? valA.localeCompare(valB) 
                    : valB.localeCompare(valA);
            } else {
                return sortDirection === 'asc' 
                    ? valA - valB 
                    : valB - valA;
            }
        });

    const steps = [
        {
            stepNum: "01",
            title: "Assessing Suitability for an SME IPO",
            desc: "The initial step involves evaluating the eligibility criteria established by the respective stock exchanges (NSE Emerge / BSE SME). It is crucial to ensure that all required documentation and reporting standards are met to minimize overall costs."
        },
        {
            stepNum: "02",
            title: "Appointment of a Merchant Banker",
            desc: "The company appoints a merchant banker registered with SEBI to act as lead manager. The merchant banker facilitates the choice of the exchange and organizes key intermediaries including registrars, market makers, and underwriters.",
            details: [
                "Capital restructuring prior to IPO",
                "Due diligence and financial statements restatement (peer-reviewed)",
                "Underwriting & planning market-making operations",
                "Drafting information memorandum and valuation parameters"
            ]
        },
        {
            stepNum: "03",
            title: "Filing the SME IPO Application",
            desc: "The merchant banker completes the listing application and submits it to the stock exchange. The exchange conducts a review of corporate records, performs site inspections, and grants approval once criteria are satisfied."
        },
        {
            stepNum: "04",
            title: "Drafting of the Prospectus",
            desc: "A Draft Red Herring Prospectus (DRHP) is prepared and filed with the stock exchange. This document outlines the business model, financial metrics, and IPO objectives. Once the review is complete, the exchange grants in-principle approval."
        },
        {
            stepNum: "05",
            title: "Filing of the Red Herring Prospectus (RHP)",
            desc: "The Red Herring Prospectus (RHP) contains finalized issue parameters including:",
            details: [
                "IPO subscription dates (open/close)",
                "Allotment timeline and listing schedules",
                "Final price bands and allocation metrics"
            ]
        },
        {
            stepNum: "06",
            title: "Roadshow and Marketing",
            desc: "The merchant banker conducts promotional campaigns and roadshows (virtual or physical) to present the company's value proposition to institutional and retail investors, building interest ahead of listing."
        },
        {
            stepNum: "07",
            title: "IPO Launch",
            desc: "The IPO bidding opens and closes on the scheduled dates. The subscription progress across all categories (retail, institutional, etc.) is monitored in real-time on the exchange platforms."
        },
        {
            stepNum: "08",
            title: "IPO Allocation of Shares",
            desc: "The registrar finalizes the allocation of shares based on subscription ratios. Share allotment statuses are updated online, and refunds are initiated for unallocated bids."
        },
        {
            stepNum: "09",
            title: "IPO Listing on the Exchange",
            desc: "The stock exchange releases the official listing announcement. Shares are credited to demat accounts, and public trading starts under the assigned ticker symbol."
        },
        {
            stepNum: "10",
            title: "Post-Listing Requirements",
            desc: "The company transitions to a listed entity, complying with ongoing disclosure requirements:",
            details: [
                "Submission of half-yearly financial results",
                "Audit reports filed within 60 days of the fiscal period",
                "Quarterly corporate governance disclosures",
                "Updates on material events and board decisions"
            ]
        }
    ];

    return (
        <div className="min-h-screen bg-slate-50 flex flex-col">
            <NavBar />
            
            <div className="flex-grow container mx-auto px-6 py-12 max-w-7xl">
                {/* Hero Section */}
                <div className="bg-gradient-premium rounded-3xl p-8 md:p-12 text-white shadow-xl mb-12 relative overflow-hidden">
                    <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/10 to-indigo-500/10 opacity-30"></div>
                    <div className="relative z-10 max-w-3xl">
                        <span className="text-cyan-400 font-bold text-sm tracking-wider uppercase mb-3 block">SME Solutions</span>
                        <h1 className="text-3xl md:text-5xl font-extrabold tracking-tight mb-6">
                            SMEs & IPOs: Unlocking Growth Capital
                        </h1>
                        <p className="text-slate-200 text-lg leading-relaxed">
                            SME IPOs enable small and medium enterprises to raise equity capital from public investors, transitioning from private entities to publicly traded corporations with simplified regulatory compliance.
                        </p>
                    </div>
                </div>

                {/* Listing Criteria Links */}
                <div className="mb-16">
                    <h2 className="text-2xl font-bold text-slate-800 mb-6 flex items-center gap-2">
                        <Award className="text-cyan-600" /> SME Listing Criteria
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-2xl">
                        <a
                            href="https://www.nseindia.com/companies-listing/raising-capital-public-issues-emerge-eligibility-criteria"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-between group"
                        >
                            <div>
                                <span className="font-semibold text-slate-800 group-hover:text-cyan-600 transition-colors">NSE SME Criteria</span>
                                <p className="text-xs text-slate-500 mt-1">NSE EMERGE public issues eligibility guidelines</p>
                            </div>
                            <span className="text-slate-400 group-hover:text-cyan-600 transition-colors">
                                <ArrowUpRight size={20} />
                            </span>
                        </a>

                        <a
                            href="https://www.bsesme.com/static/getlisted/criteriaisting.aspx?expandable=0"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-between group"
                        >
                            <div>
                                <span className="font-semibold text-slate-800 group-hover:text-cyan-600 transition-colors">BSE SME Criteria</span>
                                <p className="text-xs text-slate-500 mt-1">BSE SME public issues eligibility guidelines</p>
                            </div>
                            <span className="text-slate-400 group-hover:text-cyan-600 transition-colors">
                                <ArrowUpRight size={20} />
                            </span>
                        </a>
                    </div>
                </div>

                {/* Sector Analysis Section */}
                <div className="mb-16 bg-white rounded-3xl p-6 md:p-8 border border-slate-100 shadow-sm">
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
                        <div>
                            <h2 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
                                <Table className="text-cyan-600" /> Sectorial SME PE Analysis
                            </h2>
                            <p className="text-sm text-slate-500 mt-1">Key metrics of funds raised and median PE ratios across industries</p>
                        </div>
                        <button
                            onClick={toggleTable}
                            className="px-6 py-2.5 font-semibold text-sm rounded-xl transition duration-200 flex items-center gap-2 self-start sm:self-center shadow-md bg-cyan-600 text-white hover:bg-cyan-700 shadow-cyan-600/10 hover:shadow-cyan-600/20"
                        >
                            {showTable ? 'Hide Database' : 'Show Database'}
                        </button>
                    </div>

                    {showTable && (
                        <div>
                            {/* Search Bar */}
                            <div className="mb-5">
                                <div className="relative max-w-sm">
                                    <input
                                        type="text"
                                        placeholder="Search industries/sectors..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        className="w-full pl-10 pr-4 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-cyan-500/20 focus:border-cyan-500 transition-all bg-slate-50/50"
                                    />
                                    <span className="absolute left-3.5 top-3.5 text-slate-400">
                                        <Search size={15} />
                                    </span>
                                </div>
                            </div>

                            {/* Table */}
                            <div className="overflow-x-auto border border-slate-100 rounded-2xl">
                                <table className="w-full text-left border-collapse">
                                    <thead>
                                        <tr className="bg-slate-50 text-slate-600 border-b border-slate-100 select-none">
                                            <th 
                                                onClick={() => handleSort('sector')}
                                                className="px-6 py-4 text-xs font-semibold uppercase tracking-wider cursor-pointer hover:bg-slate-100 transition-colors"
                                            >
                                                <div className="flex items-center gap-1.5">
                                                    <span>Sector</span>
                                                    <ArrowUpDown size={12} className={sortField === 'sector' ? 'text-cyan-600 font-bold' : 'text-slate-400'} />
                                                </div>
                                            </th>
                                            <th 
                                                onClick={() => handleSort('totalIPOs')}
                                                className="px-6 py-4 text-xs font-semibold uppercase tracking-wider cursor-pointer hover:bg-slate-100 transition-colors text-center"
                                            >
                                                <div className="flex items-center justify-center gap-1.5">
                                                    <span>Total IPOs</span>
                                                    <ArrowUpDown size={12} className={sortField === 'totalIPOs' ? 'text-cyan-600 font-bold' : 'text-slate-400'} />
                                                </div>
                                            </th>
                                            <th 
                                                onClick={() => handleSort('fundsRaised')}
                                                className="px-6 py-4 text-xs font-semibold uppercase tracking-wider cursor-pointer hover:bg-slate-100 transition-colors text-right"
                                            >
                                                <div className="flex items-center justify-end gap-1.5">
                                                    <span>Funds Raised (Cr)</span>
                                                    <ArrowUpDown size={12} className={sortField === 'fundsRaised' ? 'text-cyan-600 font-bold' : 'text-slate-400'} />
                                                </div>
                                            </th>
                                            <th 
                                                onClick={() => handleSort('medianSize')}
                                                className="px-6 py-4 text-xs font-semibold uppercase tracking-wider cursor-pointer hover:bg-slate-100 transition-colors text-right"
                                            >
                                                <div className="flex items-center justify-end gap-1.5">
                                                    <span>Median Size (Cr)</span>
                                                    <ArrowUpDown size={12} className={sortField === 'medianSize' ? 'text-cyan-600 font-bold' : 'text-slate-400'} />
                                                </div>
                                            </th>
                                            <th 
                                                onClick={() => handleSort('medianPE')}
                                                className="px-6 py-4 text-xs font-semibold uppercase tracking-wider cursor-pointer hover:bg-slate-100 transition-colors text-center"
                                            >
                                                <div className="flex items-center justify-center gap-1.5">
                                                    <span>Median PE</span>
                                                    <ArrowUpDown size={12} className={sortField === 'medianPE' ? 'text-cyan-600 font-bold' : 'text-slate-400'} />
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-slate-100 text-slate-700">
                                        {filteredAndSortedData.length > 0 ? (
                                            filteredAndSortedData.map((item, index) => (
                                                <tr key={index} className="hover:bg-slate-50/50 transition-colors">
                                                    <td className="px-6 py-4 font-medium text-slate-900">{item.sector}</td>
                                                    <td className="px-6 py-4 text-center">{item.totalIPOs}</td>
                                                    <td className="px-6 py-4 text-right">₹{item.fundsRaised}</td>
                                                    <td className="px-6 py-4 text-right">₹{item.medianSize}</td>
                                                    <td className="px-6 py-4 text-center font-semibold text-cyan-600">{item.medianPE}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={5} className="px-6 py-10 text-center text-slate-400 text-sm">
                                                    No matching sectors found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>

                {/* Timeline Process Section */}
                <div className="mb-8">
                    <div className="mb-10">
                        <h2 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
                            <List className="text-cyan-600" /> Steps in the SME IPO Process
                        </h2>
                        <p className="text-slate-500 text-sm mt-1">A step-by-step roadmap from business assessment to listed trading</p>
                    </div>

                    <div className="relative pl-6 md:pl-8 border-l border-slate-200 ml-4 space-y-12">
                        {steps.map((step, idx) => (
                            <div key={idx} className="relative">
                                {/* Timeline Bullet Dot */}
                                <span className="absolute -left-[39px] md:-left-[47px] top-1 flex h-6 w-6 md:h-8 md:w-8 items-center justify-center rounded-full bg-cyan-600 text-white font-bold text-xs md:text-sm border-4 border-slate-50 shadow-sm">
                                    {step.stepNum}
                                </span>

                                <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow">
                                    <h3 className="text-lg md:text-xl font-bold text-slate-800 mb-2">
                                        {step.title}
                                    </h3>
                                    <p className="text-slate-600 text-sm md:text-base leading-relaxed">
                                        {step.desc}
                                    </p>

                                    {step.details && (
                                        <div className="mt-4 pt-4 border-t border-slate-50 grid grid-cols-1 md:grid-cols-2 gap-3">
                                            {step.details.map((detail, dIdx) => (
                                                <div key={dIdx} className="flex items-start gap-2.5 text-xs md:text-sm text-slate-500">
                                                    <span className="text-cyan-500 mt-0.5 shrink-0"><CheckCircle size={16} /></span>
                                                    <span>{detail}</span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <Clients />
        </div>
    );
};

export default SME;
